module.exports = __webpack_public_path__ + "img/cog.7274631b.svg";